import React, { useEffect } from "react";
import {
    Container,
    Row,
    Col,
    CardBody,
    CardTitle,
    CardText,
    ListGroup,
    ListGroupItem,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import KebijakanPageHeader from "../../components/Headers/KebijakanPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/css/kebijakan.css";

const KebijakanPage = () => {
    useEffect(() => {
        // Initialize AOS
        AOS.init({
            duration: 1000, // Animation duration
            once: true, // Animation happens only once
        });

        // Adding classes to body for layout consistency
        document.body.classList.add("profile-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        return () => {
            // Cleanup the classes when the component is unmounted
            document.body.classList.remove("profile-page", "sidebar-collapse");
        };
    }, []);

    return (
        <>
            {/* Navbar */}
            <ExamplesNavbar />

            <div className="wrapper">
                {/* Header */}
                <KebijakanPageHeader />
                <section className="kebijakan-privasi">
                    <Container className="mt-5">
                        <Row>
                            <Col data-aos="fade-up" data-aos-delay="200">
                                <CardBody>
                                    {/* Visi Section */}
                                    <h3>PENGANTAR</h3>
                                    <CardText className="kebijakan-text-color">
                                        Kebijakan Privasi atau Pemberitahuan Privasi (
                                        <b>“Pemberitahuan Privasi”</b>) ini mulai berlaku sejak
                                        tanggal 16 Januari 2025.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Pemberitahuan Privasi berikut ini menjelaskan bagaimana
                                        kami, Yayasan Karya Bakti United Tractors memperoleh,
                                        mengumpulkan, menyimpan, menguasai, menggunakan, mengolah,
                                        menganalisa, memperbaiki, melakukan pembaruan, menampilkan,
                                        mengumumkan, mentransfer, mengungkapkan dan melindungi data
                                        pribadi Anda (<b>“Memproses Data Pribadi”</b> atau melakukan{" "}
                                        <b>“Pemrosesan Data Pribadi”</b>) yang meliputi antara lain
                                        nama, pekerjaan, nama perusahaan, alamat surat elektronik,
                                        nomor telepon dan informasi lain yang Kami uraikan dalam
                                        bagian Ringkasan dan Rincian dari Pemberitahuan Privasi ini
                                        (<b>“Data Pribadi”</b>) yang Anda berikan ketika Anda
                                        menggunakan situs Kami, serta data-data yang terkait dengan
                                        transaksi dan/atau aktivitas yang Anda lakukan dengan
                                        menggunakan Layanan Kami (<b>“Data Transaksi”</b>).
                                        Pemberitahuan Privasi ini berlaku untuk semua pengguna
                                        website, aplikasi, dan/atau layanan yang Kami sediakan
                                        (termasuk{" "}
                                        <a href="https://www.ykbut.co.id" target="new">
                                            https://www.ykbut.co.id
                                        </a>{" "}
                                        dan situs web turunannya) yang Kami sediakan (
                                        <b>“Layanan Kami”</b>), kecuali diatur pada pemberitahuan
                                        privasi dan/atau kebijakan privasi yang terpisah.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Harap untuk membaca Pemberitahuan Privasi ini secara
                                        menyeluruh untuk memastikan bahwa Anda memahami praktik
                                        pelindungan Data Pribadi yang Kami lakukan. Kami ingin
                                        membuat Pemberitahuan Privasi ini mudah dimengerti, jadi
                                        Kami menjelaskan lebih lanjut mengenai hal-hal penting dari
                                        Pemberitahuan Privasi ini di bagian Ringkasan di bawah.
                                    </CardText>

                                    <h4>Pengakuan dan Persetujuan</h4>
                                    <CardText className="kebijakan-text-color">
                                        Dengan menyetujui Pemberitahuan Privasi ini, Anda mengakui
                                        bahwa Anda telah membaca dan memahami Pemberitahuan Privasi
                                        ini serta menyetujui segala ketentuannya. Secara khusus,
                                        Anda sepakat dan memberikan persetujuan kepada Kami untuk
                                        menyerahkan Data Pribadi Anda guna Kami Memproses Data
                                        Pribadi Anda sesuai dengan Pemberitahuan Privasi ini.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Jika Anda menyediakan kepada Kami Data Pribadi Anda yang
                                        berkaitan dengan individu lain (seperti Data Pribadi yang
                                        berkaitan dengan pasangan Anda, anggota keluarga, teman,
                                        atau pihak lain), maka Anda menyatakan dan menjamin bahwa
                                        Anda telah memperoleh persetujuan dari individu tersebut,
                                        dan dengan ini menyetujui atas nama individu tersebut, untuk
                                        Pemrosesan Data Pribadi mereka oleh Kami. Kami dapat meminta
                                        bukti dari persetujuan tersebut kepada Anda setiap saat.
                                        Berdasarkan pernyataan dan jaminan tersebut, Anda setuju
                                        untuk melindungi Kami dari setiap dan seluruh tanggung jawab
                                        hukum.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Anda dapat menarik persetujuan Anda untuk setiap atau segala
                                        Pemrosesan Data Pribadi Anda kapan saja dengan: (1)
                                        memberikan kepada Kami pemberitahuan yang wajar secara
                                        tertulis menggunakan rincian kontak yang disebutkan di bawah
                                        ini, (2) melalui fasilitas "<i>opt-out</i>", (3) pilihan
                                        "berhenti berlangganan" yang tersedia dalam pesan yang Kami
                                        kirimkan, atau (4) menggunakan opsi yang tersedia pada
                                        tiap-tiap media komunikasi yang Kami gunakan untuk
                                        menghubungi Anda. Anda harus memahami dan mengakui bahwa
                                        setelah penarikan persetujuan tersebut, Anda mungkin tidak
                                        lagi dapat menggunakan Layanan Kami. Penarikan persetujuan
                                        Anda dapat mengakibatkan penghentian Layanan Kami,
                                        penghapusan akun atau pengakhiran hubungan kontraktual Anda
                                        dengan Kami, dengan semua hak dan kewajiban yang muncul
                                        tetap dipenuhi sepenuhnya. Setelah menerima penarikan
                                        persetujuan dari Anda, Kami akan menginformasikan Anda
                                        tentang konsekuensi yang mungkin terjadi dari penarikan
                                        tersebut sehingga Anda dapat memutuskan apakah Anda tetap
                                        ingin menarik persetujuan.
                                    </CardText>

                                    <h3>RINGKASAN</h3>
                                    <h5>Data apa yang Kami kumpulkan tentang Anda?</h5>
                                    <CardText className="kebijakan-text-color">
                                        Kami mengumpulkan Data Pribadi saat Anda menggunakan Layanan
                                        Kami, termasuk data identitas, data kontak, data catatan (
                                        <i>log</i>) dan/atau data lokasi. Kami juga mengumpulkan
                                        data perangkat dan teknis dari Anda, dan data lain yang
                                        mungkin Anda sampaikan atau kirimkan saat Anda menggunakan
                                        Layanan Kami. Jika Anda memilih untuk tidak menyediakan data
                                        tersebut, Kami mungkin tidak dapat menyediakan layanan
                                        kepada Anda secara normal.
                                    </CardText>

                                    <h5>Berapa lama Kami memproses data Anda?</h5>
                                    <CardText className="kebijakan-text-color">
                                        Kami memproses data Anda selama Anda memanfaatkan Layanan
                                        Kami dan Anda memberikan persetujuan yang diperlukan untuk
                                        memenuhi tujuan perolehan dan pengumpulannya, atau
                                        sebagaimana diwajibkan oleh peraturan perundang-undangan
                                        yang berlaku terkait pelindungan Data Pribadi yang berlaku
                                        di Indonesia (
                                        <b>“Peraturan Perundang-undangan yang Berlaku”</b>).
                                    </CardText>

                                    <h5>
                                        Bagaimana Anda bisa melaksanakan hak Anda atas Data Pribadi
                                        Anda?
                                    </h5>
                                    <CardText className="kebijakan-text-color">
                                        Anda mungkin memiliki berbagai hak sehubungan dengan Data
                                        Pribadi Anda berdasarkan Peraturan Perundang-undangan yang
                                        Berlaku. Jika Anda ingin mengajukan permohonan pelaksanaan
                                        hak Anda, Anda dapat mengajukan permohonan kepada Kami,
                                        termasuk permohonan penghapusan data dengan menghubungi
                                        layanan di bagian Hubungi Kami.
                                    </CardText>

                                    <h5>Hubungi Kami</h5>
                                    <CardText className="kebijakan-text-color">
                                        Dalam hal Anda memiliki pertanyaan, komentar, keluhan, atau
                                        klaim mengenai Pemberitahuan Privasi ini atau Anda ingin
                                        melakukan perubahan dan/atau pembaruan terhadap setiap Data
                                        Pribadi yang Anda serahkan kepada Kami, silakan hubungi
                                        layanan Kami melalui surat elektronik ke{" "}
                                        <a href="mailto:official@ykbut.co.id">
                                            official@ykbut.co.id
                                        </a>
                                        .
                                    </CardText>

                                    <h5>
                                        Bagaimana Kami akan memberitahukan Anda terkait perubahan?
                                    </h5>
                                    <CardText className="kebijakan-text-color">
                                        Kami dapat mengubah Pemberitahuan Privasi ini dari waktu ke
                                        waktu dan Kami dapat memberitahu Anda tentang versi yang
                                        diperbarui melalui Layanan Kami atau surat elektronik Anda
                                        yang terdaftar pada Kami (sebagaimana relevan). Silakan
                                        periksa kembali secara berkala untuk melihat pembaruan atau
                                        perubahan apapun pada Pemberitahuan Privasi ini.
                                    </CardText>

                                    <CardText className="kebijakan-text-color">
                                        Penjelasan lebih lanjut tentang Ringkasan di atas dapat
                                        dibaca pada bagian Rincian di bawah ini.
                                    </CardText>
                                    <h3>RINCIAN</h3>
                                    <h4>DATA PRIBADI YANG KAMI KUMPULKAN</h4>
                                    <CardText className="kebijakan-text-color">
                                        Data Pribadi adalah data yang dapat digunakan untuk
                                        mengidentifikasi, menghubungi, atau menemukan seseorang atau
                                        perangkat yang digunakan yang terhubung dengan data
                                        tersebut. Data Pribadi terdiri dari namun tidak terbatas
                                        pada nama, alamat, tanggal lahir, nomor telefon, alamat
                                        surat elektronik, kartu identitas yang dikeluarkan oleh
                                        Pemerintah Indonesia atau dokumen identitas lainnya yang
                                        dikeluarkan oleh pemerintah atau otoritas yang berwenang,
                                        data terkait keuangan dan/atau data lainnya yang dapat
                                        digunakan untuk mengidentifikasi seseorang baik pada saat
                                        data tersebut digunakan secara tersendiri maupun saat
                                        dikombinasikan dengan informasi lainnya sebagaimana diatur
                                        dalam Peraturan Perundang-undangan yang Berlaku.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Data Pribadi yang Kami kumpulkan bergantung pada jenis
                                        layanan yang digunakan atau transaksi yang dilakukan oleh
                                        Anda, karyawan, atau pemilik data pribadi lainnya yang
                                        memasukkan data pribadinya pada Layanan Kami.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Kami dapat melakukan pemrosesan Data Pribadi yang terdiri
                                        dari aktivitas pengumpulan, penggunaan, penyimpanan,
                                        pembuatan analisis berdasarkan data tersebut, pentransferan
                                        data, pengembangan aplikasi maupun penghapusan dan
                                        pemusnahan data pribadi, selama hal tersebut tidak
                                        bertentangan dengan Peraturan Perundang-undangan yang
                                        Berlaku dan memenuhi ketentuan dasar pemrosesan data pribadi
                                        sebagaimana diatur dalam Peraturan Perundang-undangan yang
                                        Berlaku. Saat Anda menggunakan Layanan Kami, Anda memberikan
                                        persetujuan dengan (i) mencentang <i>pop-up message</i>{" "}
                                        terkait pemberian persetujuan Penggunaan Data Pribadi yang
                                        tertera dalam laman Kami, (ii) memilih bagaimana penggunaan
                                        Data Pribadi dapat dilakukan, dan apakah Anda yang dalam hal
                                        ini menggunakan Layanan Kami memberikan persetujuan untuk
                                        menerima iklan promosi, (iii) atau persetujuan yang
                                        diberikan oleh Anda saat Anda memasukkan Data Pribadi dalam
                                        pembuatan akun maupun saat terdapat penggunaan Layanan Kami
                                        tertentu. Adapun Data Pribadi yang diproses oleh Kami
                                        dikelompokkan kembali menjadi sebagai berikut:
                                    </CardText>
                                    <h4>Data Pribadi terkait Anda</h4>
                                    <CardText className="kebijakan-text-color">
                                        Identitas Anda yang terdiri dari antara lain, nama, alamat
                                        tempat tinggal, setiap data yang tersedia pada Kartu Tanda
                                        Penduduk, kata sandi, nomor telepon, alamat surat
                                        elektronik, jabatan, identitas terkait perpajakan, dan/atau
                                        informasi lain yang dapat menunjukan identitas diri Anda.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Data keuangan yang terdiri antara lain atas (i) nomor
                                        rekening dari Anda, (ii) nomor kartu kredit, bank yang
                                        menerbitkan kartu kredit, nomor identifikasi, kode
                                        verifikasi kartu kredit, tanggal kadaluarsa kartu,{" "}
                                        <i>credit scoring</i> dan riwayat keuangan Anda dalam hal
                                        pembayaran dilakukan menggunakan kartu kredit, (iii) dalam
                                        hal pembayaran dilakukan menggunakan fasilitas pembiayaan
                                        yang dimiliki oleh Anda dan Pihak ketiga, maka terdapat data
                                        tambahan yang diperlukan berupa salinan perjanjian
                                        pembiayaan antara Anda dan pihak ketiga, dan/atau data
                                        keuangan lain yang relevan sebagaimana diperlukan untuk
                                        memastikan pembayaran dilakukan.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Data pembayaran meliputi bukti pembayaran yang dilakukan
                                        oleh Anda pada Layanan Kami, yang juga akan mencakup
                                        informasi mengenai metode yang dipilih untuk melakukan
                                        pembayaran, rincian tagihan, rincian faktur, dan/atau data
                                        lain yang relevan yang diperlukan untuk mengonfirmasi
                                        pembayaran.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Data teknis yang terdiri dari (i) <i>IP Address</i> yang
                                        digunakan oleh Anda saat mengakses Layanan Kami, (ii){" "}
                                        <i>history</i> penggunaan Layanan Kami, (iii) produk yang
                                        sering diakses, dan (iv) durasi yang digunakan oleh
                                        masing-masing Anda dalam mengakses Layanan Kami, (v) data
                                        terkait penggunaan perangkat yang digunakan untuk mengakses
                                        Layanan Kami, (vi) <i>cookies</i> yang dapat digunakan untuk
                                        mengidentifikasi aktivitas Anda pada Layanan Kami, maupun
                                        data lainnya yang dapat membantu Anda untuk mendapatkan
                                        informasi yang relevan terkait produk yang diinginkan
                                        dan/atau informasi yang telah dipersonalisasikan sesuai
                                        kebutuhan Anda.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Informasi mengenai lokasi termasuk pada lokasi terdekat
                                        pengiriman produk dan/atau jasa Kami, dan/atau{" "}
                                        <i>geolocation</i> yang ditangkap oleh Layanan Kami.
                                    </CardText>

                                    <h4>
                                        Data Pribadi Karyawan Kami (jika Anda merupakan karyawan
                                        Kami)
                                    </h4>
                                    <CardText className="kebijakan-text-color">
                                        Identitas Anda yang terdiri dari nama, alamat tempat
                                        tinggal, setiap data yang tersedia pada Kartu Tanda
                                        Penduduk, kata sandi, nomor telepon, alamat surat
                                        elektronik, nomor identitas karyawan, jabatan, identitas
                                        terkait perpajakan, dan/atau informasi lain yang dapat
                                        menunjukan identitas diri Anda.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Data keuangan yang terdiri dari antara lain nomor rekening
                                        Anda dan/atau data keuangan lain yang relevan sebagaimana
                                        diperlukan Kami dalam hubungan kerja dengan Anda sebagai
                                        karyawan Kami.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Data teknis yang terdiri dari (i) <i>IP Address</i> yang
                                        digunakan oleh Anda saat mengakses Layanan Kami, khususnya
                                        yang tersedia untuk karyawan Kami, (ii) <i>history</i>{" "}
                                        penggunaan Layanan Kami, (iii) durasi yang digunakan oleh
                                        masing-masing Anda dalam mengakses Layanan Kami, (iv)
                                        kehadiran Anda sebagai karyawan Kami, (v) data terkait
                                        penggunaan perangkat yang digunakan untuk mengakses Layanan
                                        Kami, dan/atau data teknis lainnya terkait penggunaan
                                        Layanan Kami oleh Anda sebagai karyawan Kami.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Informasi mengenai lokasi Anda sebagai karyawan Kami yang
                                        didapatkan saat Anda menuliskan lokasi Anda ataupun yang
                                        dihasilkan oleh <i>geolocation</i> yang harus diaktifkan
                                        saat Anda mengakses Layanan Kami khusus untuk karyawan Kami.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Informasi yang bersifat khusus seperti rekam medis,
                                        informasi kesehatan, data anak, data pasangan, informasi
                                        mengenai gaji, dan/atau data lainnya yang diperlukan Kami
                                        dalam hubungan kerja dengan Anda sebagai karyawan Kami.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Kami dapat mengkombinasikan Data Pribadi yang didapatkan
                                        untuk keperluan statistik, demografi, maupun dalam
                                        pengembangan Layanan Kami (selanjutnya disebut sebagai{" "}
                                        <b>“Data yang Dikombinasi”</b>). Data yang Dikombinasi pada
                                        dasarnya tidak akan mengungkapkan Data Pribadi. Kami akan
                                        tetap memastikan bahwa Data yang Dikombinasi tidak akan
                                        dapat digunakan untuk mengidentifikasi seseorang, atau tidak
                                        dapat dikaitkan atau dihubungkan dengan siapapun.
                                    </CardText>
                                    <h5>Ketepatan dan Kelengkapan Data</h5>
                                    <CardText className="kebijakan-text-color">
                                        Pada dasarnya Anda dapat menggunakan hak Anda untuk meminta
                                        perbaikan data dalam hal terdapat data pribadinya yang
                                        keliru, di sisi lain Kami juga harus memastikan bahwa Data
                                        Pribadi yang disediakan oleh Anda merupakan data yang benar
                                        dan juga lengkap. Oleh karena itu, Anda wajib menyampaikan
                                        Data Pribadi kepada Kami secara benar dan lengkap. Dalam hal
                                        Anda gagal dan/atau lalai menyampaikan Data Pribadi secara
                                        lengkap dan benar, maka: (i) Anda tidak dapat memanfaatkan
                                        Layanan Kami secara maksimal, (ii) Anda tidak dapat
                                        mengakses dan/atau memanfaatkan Layanan Kami, atau (iii)
                                        Kami tidak bertanggung jawab atas kelalaian dan/atau
                                        kegagalan Anda dalam menyampaikan Data Pribadi secara
                                        lengkap dan benar. Untuk menghindari keragu-raguan, dalam
                                        hal terdapat Anda yang tidak melengkapi identitas sedangkan
                                        identitas diperlukan untuk melaksanakan perjanjian yang
                                        disepakati, terdapat kemungkinan bahwa Kami tidak dapat
                                        menyediakan layanan terkait.
                                    </CardText>
                                    <h5>Sumber Perolehan Data Pribadi</h5>
                                    <CardText className="kebijakan-text-color">
                                        Kami melakukan perolehan Data Pribadi baik melalui (i) Anda
                                        secara langsung, (ii) diperoleh pada saat Anda mengakses
                                        Layanan Kami, dan (iii) informasi maupun data mengenai pihak
                                        ketiga yang diberikan oleh Anda...
                                    </CardText>

                                    <h3>PENGGUNAAN DATA PRIBADI</h3>
                                    <h5>Bagaimana Kami menggunakan Data Pribadi Anda?</h5>
                                    <CardText className="kebijakan-text-color">
                                        Anda dengan ini memberikan persetujuan secara tegas kepada
                                        Kami untuk dapat menggunakan Data Pribadi yang dikumpulkan
                                        untuk tujuan sebagai berikut maupun untuk tujuan lain yang
                                        diizinkan oleh peraturan perundang-undangan yang berlaku
                                        termasuk namun tidak terbatas pada (<b>"Tujuan"</b>):
                                        <ul className="kebijakan-list">
                                            <li>Menanggapi pertanyaan, komentar atau keluhan;</li>
                                            <li>
                                                Berkomunikasi dengan Anda melalui berbagai media
                                                seperti notifikasi dalam Layanan Kami, surat
                                                elektronik, telepon, layanan pesan singkat (SMS),
                                                layanan percakapan (<i>chatting</i>) pesan singkat
                                                dalam aplikasi (
                                                <i>in-app messaging/ push notifications</i>), maupun
                                                media sosial;
                                            </li>
                                            <li>
                                                Pemasaran dan promosi produk dan/atau layanan yang
                                                Kami sediakan dan/atau perusahaan afiliasi Kami,
                                                termasuk pengumuman, materi promosi, ucapan salam,
                                                undangan untuk berpartisipasi dan hak-hak istimewa
                                                yang berasal dari perusahaan afiliasi Kami, mitra
                                                Kami, sponsor maupun pemasang iklan;
                                            </li>
                                            <li>
                                                Memproses partisipasi Anda dalam setiap kegiatan
                                                produksi, kontes, permainan, promosi, jajak pendapat
                                                maupun <i>survey</i>;
                                            </li>
                                            <li>
                                                Memahami dan menganalisis pola penggunaan dan
                                                penjualan produk dan/atau penyediaan layanan bagi
                                                kebutuhan dan/atau preferensi Anda;
                                            </li>
                                            <li>
                                                Mengembangkan, meningkatkan dan menyediakan produk
                                                dan/atau layanan yang sesuai dengan kebutuhan Anda;
                                            </li>
                                            <li>
                                                Melaksanakan hubungan hukum antara Anda dengan Kami;
                                                dan/atau
                                            </li>
                                            <li>
                                                proses administrasi internal dan/atau kepatuhan
                                                terhadap hukum yang berlaku di Indonesia, seperti
                                                namun tidak terbatas pada pelaksanaan audit dan/atau
                                                terkait perpajakan.
                                            </li>
                                        </ul>
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Kami berupaya secara wajar untuk melindungi setiap Data
                                        Pribadi dan/atau Data Transaksi Anda. Kami senantiasa
                                        berusaha meningkatkan standar perlindungan Layanan Kami.
                                        Adapun demikian, Kami tidak bertanggung jawab atas setiap
                                        kerugian yang timbul akibat rusaknya atau hilangnya Data
                                        Pribadi dan/atau Data Transaksi Anda yang terjadi di luar
                                        kendali Kami. Oleh karena itu, Kami sangat menyarankan agar
                                        Anda selalu memperbaharui data pada akun Anda dan perangkat
                                        lunak yang Anda pergunakan serta tidak mengungkapkan kata
                                        sandi akun Anda kepada pihak mana pun.
                                    </CardText>
                                    <h5>Bagaimana Kami mengungkapkan Data Pribadi Anda?</h5>
                                    <CardText className="kebijakan-text-color">
                                        Anda dengan ini memberikan persetujuan secara tegas kepada
                                        Kami bahwa untuk tujuan bisnis dan operasional maupun
                                        keperluan lain, Kami dapat melakukan kerja sama dengan pihak
                                        ketiga terkait pemanfaatan atas Data Pribadi dan/atau Data
                                        Transaksi Anda. Pihak ketiga tersebut termasuk namun tidak
                                        terbatas pada:
                                        <ul className="kebijakan-list">
                                            <li>
                                                perusahaan riset dan pemasaran terkait promosi
                                                produk dan/atau layanan yang Kami sediakan;
                                            </li>
                                            <li>
                                                perusahaan penyedia layanan terkait teknologi
                                                informasi (termasuk layanan infrastruktur, komputasi
                                                awan (<i>cloud computing</i>), perangkat lunak,
                                                analisa <i>big data</i> dan <i>machine learning</i>,
                                                termasuk di dalamnya layanan{" "}
                                                <i>data cleansing, data insight</i> dan{" "}
                                                <i>credit scoring</i>);
                                            </li>
                                            <li>
                                                perusahaan penyedia jasa pemrosesan transaksi
                                                pembayaran yang meliputi penyelenggara{" "}
                                                <i>payment gateway</i>, transfer dana, dompet
                                                elektronik, uang elektronik dan penyelenggara jasa
                                                sistem pembayaran lainnya terkait transaksi yang
                                                dilakukan dalam Situs;
                                            </li>
                                            <li>
                                                perusahaan penyedia layanan lainnya maupun mitra
                                                Kami yang terkait dengan produk dan/atau layanan
                                                yang Kami sediakan (termasuk namun tidak terbatas
                                                pada perusahaan asuransi dan/atau perusahaan
                                                penyedia jasa kesehatan untuk layanan bagi karyawan
                                                Kami);
                                            </li>
                                            <li>
                                                penasihat profesional dan auditor eksternal,
                                                termasuk penasihat hukum, penasihat keuangan dan
                                                konsultan lainnya;
                                            </li>
                                            <li>
                                                otoritas pemerintah, baik di dalam maupun di luar
                                                yurisdiksi negara Republik Indonesia sesuai
                                                peraturan perundang-undangan yang berlaku; dan/atau
                                            </li>
                                            <li>
                                                pihak-pihak lainnya sesuai dengan peraturan
                                                perundang-undangan yang berlaku di Indonesia.
                                            </li>
                                        </ul>
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Ketika terdapat Data Pribadi yang tidak perlu dikaitkan
                                        dengan Anda, Kami akan melakukan upaya yang wajar untuk
                                        menghapus kaitan Data Pribadi tersebut dengan Anda sebagai
                                        individu sebelum mengungkapkan atau berbagi Data Pribadi
                                        tersebut.
                                    </CardText>

                                    <h5>MELINDUNGI DATA PRIBADI ANDA</h5>
                                    <h5>Keamanan Data</h5>
                                    <CardText className="kebijakan-text-color">
                                        Kami sangat menghargai Data Pribadi dan/atau Data Transaksi
                                        Anda dan berupaya secara wajar untuk melindungi setiap Data
                                        Pribadi dan/atau Data Transaksi. Kami senantiasa berusaha
                                        meningkatkan standar perlindungan Layanan Kami, namun
                                        demikian, Kami tidak bertanggung jawab atas setiap kerugian
                                        yang timbul akibat rusaknya atau hilangnya Data Pribadi
                                        dan/atau Data Transaksi Anda yang terjadi di luar kendali
                                        Kami. Oleh karena itu, Kami sangat menyarankan agar Anda
                                        selalu memperbaharui akun Anda dan perangkat lunak Anda
                                        serta tidak mengungkapkan kata sandi akun Situs anda kepada
                                        pihak manapun.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Anda dengan ini memberikan persetujuan secara tegas kepada
                                        Kami bahwa Kami dapat mengirimkan, menyimpan, menggunakan
                                        dan/atau mengolah Data Pribadi dan/atau Data Transaksi Anda
                                        pada <i>server</i> yang terletak di pusat data yang ditunjuk
                                        oleh Kami. Pusat data tersebut dapat dikelola oleh pihak
                                        ketiga dan/atau terletak di dalam dan/atau di luar wilayah
                                        negara Republik Indonesia. Meskipun demikian, pemanfaatan
                                        Data Pribadi dan/atau Data Transaksi Anda sehubungan dengan
                                        penggunaan Layanan Kami akan terus diatur oleh Kebijakan
                                        Privasi ini sesuai dengan Peraturan Perundang-undangan yang
                                        Berlaku.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Kami berkomitmen untuk melindungi Data Pribadi Anda. Kami
                                        menerapkan langkah-langkah teknis yang sepatutnya untuk
                                        membantu melindungi keamanan Data Pribadi Anda; namun, harap
                                        dipahami bahwa tidak ada sistem yang akan sepenuhnya aman.
                                    </CardText>
                                    <h5>Penyimpanan Data</h5>
                                    <CardText className="kebijakan-text-color">
                                        Kami menyimpan Data Pribadi Anda untuk tujuan bisnis yang
                                        sah dan penting, seperti termasuk namun tidak terbatas pada
                                        menjaga Layanan Kami, membuat keputusan bisnis berdasarkan
                                        data dan/atau akses pada Layanan Kami dan Data Pribadi yang
                                        Kami peroleh dari Anda, mematuhi kewajiban hukum bagi Kami,
                                        dan/atau untuk menyelesaikan sengketa. Kami menyimpan
                                        sebagian dan/atau seluruh dari Data Pribadi dan/atau Data
                                        Transaksi selama paling singkat 5 (lima) tahun dan paling
                                        lama sesuai dengan ketentuan peraturan perundang-undangan
                                        yang berlaku di Indonesia, atau hingga terdapat permintaan
                                        khusus dari Anda untuk menghapusa Data Pribadi Anda.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Apabila Anda meminta, Kami akan menghapus Data Pribadi Anda
                                        agar data tersebut tidak lagi mengidentifikasi Anda, kecuali
                                        apabila Kami secara hukum diperbolehkan atau disyaratkan
                                        untuk menyimpan Data Pribadi tertentu atau menyimpan data
                                        dengan cara menganonimkan data atau menerapkan
                                        pseudonomisasi, termasuk namun tidak terbatas pada situasi
                                        berikut ini:
                                    </CardText>
                                    <ul className="kebijakan-list">
                                        <li>
                                            apabila Kami perlu untuk menyimpan Data Pribadi untuk
                                            memenuhi kewajiban hukum bagi Kami, termasuk namun tidak
                                            terbatas pada kewajiban terkait pajak, pelaksanaan
                                            audit, dan/atau pelaksanaan hukum yang berlaku bagi
                                            Kami, Kami akan menyimpan Data Pribadi yang diperlukan
                                            selama jangka waktu yang disyaratkan oleh hukum yang
                                            berlaku; dan/atau
                                        </li>
                                        <li>
                                            apabila diperlukan untuk kepentingan bisnis Kami yang
                                            sah, seperti pencegahan tindak pidana pencucian uang,
                                            peningkatan layanan yang Kami sediakan (termasuk
                                            penjualan produk dan/atau jasa Kami, dan layanan Kami
                                            terhadap karyawan Kami) dan/atau untuk menjaga keamanan
                                            Data Pribadi.
                                        </li>
                                    </ul>
                                    <CardText className="kebijakan-text-color">
                                        Mohon diperhatikan bahwa masih ada kemungkinan bahwa
                                        beberapa Data Pribadi Anda disimpan dan/atau dikuasai oleh
                                        pihak lain termasuk institusi pemerintah dengan cara
                                        tertentu. Dalam hal Kami membagikan Data Pribadi Anda kepada
                                        institusi pemerintah yang berwenang dan/atau institusi
                                        lainnya yang dapat ditunjuk oleh pemerintah yang berwenang
                                        atau memiliki kerja sama dengan Kami, Anda menyetujui dan
                                        mengakui bahwa penyimpanan Data Pribadi Anda oleh institusi
                                        terkait akan mengikuti kebijakan penyimpanan data
                                        masing-masing institusi tersebut.
                                    </CardText>

                                    <h3>HAK ANDA SEBAGAI PENGGUNA</h3>
                                    <h5>Hak Hukum Anda</h5>
                                    <CardText className="kebijakan-text-color">
                                        Anda mungkin memiliki hak tertentu berdasarkan Peraturan
                                        Perundang-undangan yang Berlaku untuk meminta kepada Kami
                                        terhadap akses kepada, koreksi dari dan/atau penghapusan
                                        terhadap Data Pribadi Anda yang berada dalam penguasaan
                                        dan/atau kendali Kami.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Kami dapat menolak permintaan Anda terhadap akses pada,
                                        koreksi dari dan/atau penghapusan terhadap, sebagian atau
                                        semua Data Pribadi Anda yang Kami kuasai dan/atau kendalikan
                                        jika diperbolehkan atau diperlukan berdasarkan Peraturan
                                        Perundang-undangan yang Berlaku. Hal ini termasuk dalam
                                        keadaan di mana Data Pribadi tersebut dapat berisi referensi
                                        kepada orang lain atau di mana permintaan untuk akses atau
                                        permintaan untuk mengoreksi atau menghapus adalah untuk
                                        alasan yang Kami anggap tidak relevan, tidak serius,
                                        mengada-ada, atau terindikasi terkait dengan tindakan
                                        pelanggaran syarat dan ketentuan atau pelanggaran hukum.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Sesuai Peraturan Perundang-undangan yang Berlaku, Kami
                                        memiliki hak untuk membebankan biaya administratif untuk
                                        setiap permintaan akses dan/atau koreksi.
                                    </CardText>

                                    <h3>CATATAN TAMBAHAN</h3>
                                    <h5>Hukum yang Berlaku</h5>
                                    <CardText className="kebijakan-text-color">
                                        Pemberitahuan Privasi ini diatur dan ditafsirkan menurut
                                        hukum yang berlaku di negara Republik Indonesia dan setiap
                                        sengketa yang timbul dari Pemberitahuan Privasi ini akan
                                        diselesaikan melalui Pengadilan Negeri Jakarta Timur.
                                    </CardText>
                                    <h5>Situs Web dan Layanan Lain</h5>
                                    <CardText className="kebijakan-text-color">
                                        Layanan Kami dapat berisi tautan ke situs web yang
                                        dioperasikan oleh pihak ketiga. Segala pemrosesan Data
                                        Pribadi pada situs web tersebut sepenuhnya dikendalikan oleh
                                        pihak ketiga dan berada di bawah pertanggungjawaban pihak
                                        ketiga. Jika Anda setuju untuk mengakses situs web yang
                                        dioperasikan oleh pihak ketiga tersebut, maka Anda tunduk
                                        pada syarat dan ketentuan serta pemberitahuan privasi dari
                                        situs web pihak ketiga. Oleh karena itu, Kami tidak
                                        bertanggung jawab terhadap syarat dan ketentuan serta
                                        pemberitahuan privasi dari situs web pihak ketiga tersebut,
                                        dan Kami sarankan Anda untuk membaca syarat dan ketentuan
                                        dan pemberitahuan privasi dari situs web pihak ketiga
                                        tersebut untuk mengetahui bagaimana mereka mengumpulkan dan
                                        menggunakan Data Pribadi Anda.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Iklan yang terdapat pada Layanan Kami atau Materi Pemasaran
                                        (sebagaimana didefinisikan di bawah) Kami berfungsi sebagai
                                        tautan ke situs web pengiklan dan dengan demikian segala
                                        data yang mereka kumpulkan berdasarkan akses Anda pada
                                        tautan itu akan dikumpulkan dan digunakan oleh pengiklan
                                        yang relevan sesuai dengan kebijakan privasi pengiklan
                                        tersebut.
                                    </CardText>
                                    <h5>Materi Pemasaran dan Promosi</h5>
                                    <CardText className="kebijakan-text-color">
                                        Kami dan dan/atau pihak ketiga lainnya yang berhubungan
                                        dengan Kami untuk kepentingan kegiatan komersial dan/atau
                                        non-komersial dapat mengirimkan Anda pemasaran langsung,
                                        iklan, dan komunikasi promosi melalui aplikasi{" "}
                                        <i>push-notification</i>, pesan melalui Website dan
                                        Aplikasi, pos, platform chat, media sosial, dan <i>email</i>{" "}
                                        (<b>“Materi Pemasaran”</b>) jika Anda telah setuju untuk
                                        berlangganan milis Kami, dan/atau setuju untuk menerima
                                        Materi Pemasaran dan/atau promosi dari Kami. Anda dapat
                                        memilih untuk tidak menerima komunikasi pemasaran tersebut
                                        kapan saja dengan mengklik pilihan “berhenti berlangganan”
                                        yang ada dalam pesan yang bersangkutan, metode lain yang
                                        tersedia pada media promosi tersebut atau menghubungi Kami
                                        melalui detail kontak yang tercantum di bawah.
                                    </CardText>
                                    <CardText className="kebijakan-text-color">
                                        Mohon perhatikan bahwa jika Anda memilih untuk tidak
                                        menerima Materi Pemasaran, Kami masih dapat mengirimi Anda
                                        pesan-pesan non-promosi, seperti tanda terima atau data
                                        tentang akun Anda.
                                    </CardText>
                                    <h5>Pembaharuan Terhadap Pemberitahuan Privasi</h5>
                                    <CardText className="kebijakan-text-color">
                                        Kami dapat meninjau kembali dan mengubah Pemberitahuan
                                        Privasi ini atas kebijakan Kami sendiri dari waktu ke waktu,
                                        untuk memastikan bahwa Pemberitahuan Privasi ini konsisten
                                        dengan perkembangan Kami di masa depan, dan/atau perubahan
                                        persyaratan hukum atau peraturan yang berlaku di Indonesia.
                                        Jika Kami memutuskan untuk mengubah Pemberitahuan Privasi
                                        ini, Kami dapat memberitahu Anda tentang perubahan tersebut
                                        melalui kanal resmi Kami (sebagaimana relevan). Anda setuju
                                        bahwa Anda bertanggung jawab untuk memeriksa Pemberitahuan
                                        Privasi ini secara berkala untuk mengetahui data terbaru
                                        tentang pengolahan data dan praktik pelindungan data Kami,
                                        dan bahwa dengan Anda terus menggunakan Layanan Kami,
                                        berkomunikasi dengan Kami, atau mengakses dan menggunakan
                                        layanan setelah adanya perubahan apapun terhadap
                                        Pemberitahuan Privasi ini akan dianggap sebagai persetujuan
                                        Anda terhadap Pemberitahuan Privasi ini dan segala
                                        perubahannya.
                                    </CardText>
                                </CardBody>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Footer */}
                <DefaultFooter />
            </div>
        </>
    );
};

export default KebijakanPage;
